// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
require("../stubs/billingInformation/billingInformation.less");

const invoiceRowHtml = require("./html/invoiceRow.html");
const noInvoicesRowHtml = require("./html/noInvoicesRow.html");
const emailLineHtml = require("./html/emailLine.html");

import run from '../../utilities/run';
import $ from 'jquery';
import _ from "underscore";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT} from "../../constants";

run("#billing-management-page", ()=> {
  const INITIAL_NUMBER_OF_ROWS = 5;
  const LOAD_MORE_INCREMENT = 5;
  const MAX_DISPLAY = 15;
  const MAX_CC_EMAILS = 3;

  const billingManagementPage = $("#billing-management-page");
  const invoicesTableBody = $("#invoices-table-body");
  const loadMoreBtn = $("#load-more-btn");
  const allLoadedMessage = $("#all-loaded-message");
  const invoiceInquiryModal = $("#invoice-inquiry-modal");
  const invoiceContent = $("#invoiceText");
  const emailContainer = $(".email-rows-container");
  const addRecipientBtn = $("#add-recipient-btn");
  const inquirySubmitBtn = $("#inquiry-modal-submit-btn");

  const getInvoiceUrl = billingManagementPage.data("get-invoice-url");
  const sendInvoiceInquiryUrl = billingManagementPage.data("send-invoice-inquiry-url");
  const invoices = billingManagementPage.data("invoices");

  const numberOfInvoices = invoices.length;
  let numberOfDisplayedInvoices = 0;
  let numberOfEmailRows = 0;
  let inquiryInvoiceNumber;
  let inquiryInvoiceDate;

  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();

  initializePage();

  function initializePage() {
    if (numberOfInvoices === 0) {
      invoicesTableBody.append(noInvoicesRowHtml);
    } else {
      buildInvoiceTableRows(0, getEndIndex(0, INITIAL_NUMBER_OF_ROWS));
    }
    setLoadMoreBtnDisplay();
  }

  function getEndIndex(start, offset) {
    const end = start + offset;
    return (numberOfInvoices < end) ? numberOfInvoices : end;
  }

  function buildInvoiceTableRows(start, end) {
    const invoiceRange = _.range(start, end);
    _.each(invoiceRange, addInvoiceRow);
  }

  function addInvoiceRow(invoiceIndex) {
    const invoice = invoices[invoiceIndex];
    const htmlTemplate = _.template(invoiceRowHtml);    
    const pillColor = getPillColor(invoice.status);
    const params = {
      invoiceId : invoice.invoiceId, 
      invoiceNumber : invoice.invoiceNumber, 
      invoiceDate : invoice.invoiceDate, 
      dueDate : invoice.dueDate, 
      amountDue : invoice.amountDue, 
      remaining : invoice.balance, 
      status : invoice.status, 
      pdfUrl : invoice.pdfFileUrl,
      pillColor : pillColor
    };
    invoicesTableBody.append(htmlTemplate(params));
    numberOfDisplayedInvoices++;
  }

  function getPillColor(status) {
    if (status === "Paid") {
      return "q-pill-blue";
    } else {
      return "q-pill-white-and-blue";
    }
  }

  function getInvoicePdf(invoiceId, pdfUrl) {
    const url = getInvoiceUrl.concat(`&fileName=Invoice.pdf&invoiceId=${invoiceId}&pdfUrl=${pdfUrl}`);
    let labelWindow = window.open(url, 'labelWindow');
    labelWindow.document.title = 'Invoice';
  }

  function getEmailRecipients() {
    let emailRecipients = [];
    $(".email-recipient").each(function() {
      emailRecipients.push($(this).val());
    });
    return emailRecipients;
  }

  function setLoadMoreBtnDisplay() {
    (numberOfDisplayedInvoices < MAX_DISPLAY && numberOfDisplayedInvoices < numberOfInvoices) ? loadMoreBtn.show() : loadMoreBtn.hide();
  }

  function setAllLoadedMessageDisplay() {
    (numberOfDisplayedInvoices === MAX_DISPLAY) ? allLoadedMessage.show() : allLoadedMessage.hide();
  }

  function setAddRecipientBtnDisplay() {
    (numberOfEmailRows === MAX_CC_EMAILS) ? addRecipientBtn.hide() : addRecipientBtn.show();
  }

  loadMoreBtn.click(function(e) {
    e.preventDefault();
    buildInvoiceTableRows(numberOfDisplayedInvoices, getEndIndex(numberOfDisplayedInvoices, LOAD_MORE_INCREMENT));
    setLoadMoreBtnDisplay();
    setAllLoadedMessageDisplay();
  });

  addRecipientBtn.click(function(e) {
    e.preventDefault();
    emailContainer.append(emailLineHtml);
    numberOfEmailRows++;
    setAddRecipientBtnDisplay();
  });

  inquirySubmitBtn.click(function(e) {
    e.preventDefault();
    invoiceInquiryModal.modal('hide');
    submitModalFlow.showLoadingModal();
    submitInquiry();
  });

  $(document).on("click", '.get-invoice-link', function(e) {
    e.preventDefault();
    const invoiceId = $(this).data('invoice-id');
    const pdfUrl = $(this).data('pdf-url');
    getInvoicePdf(invoiceId, pdfUrl);
  });

  $(document).on('click', '.send-inquiry-link', function(e) {
    e.preventDefault();
    inquiryInvoiceNumber = $(this).data('invoice-number');
    inquiryInvoiceDate = $(this).data('invoice-date');
    invoiceInquiryModal.modal('show');
    emailContainer.empty();
    invoiceContent.val('');
    numberOfEmailRows = 0;
    addRecipientBtn.show();
  });

  $(document).on('click', '.remove-email-row', function(e) {
    e.preventDefault();
    $(this).parent().closest('div').remove();
    numberOfEmailRows--;
    setAddRecipientBtnDisplay();
  });

  function submitInquiry() {
    const emailRecipients = getEmailRecipients();
    $.ajax({
      global: false,
      url: sendInvoiceInquiryUrl,
      type: 'POST',
      data: {
        inquiryContent: invoiceContent.val(),
        invoiceNumber: inquiryInvoiceNumber,
        invoiceDate: inquiryInvoiceDate,
        extraRecipients: emailRecipients
      },
      success: submitInquirySuccess,
      error: submitInquiryError
    });
  }

  function submitInquirySuccess() {
    submitModalFlow.showSuccessModal();
    setTimeout(function() {
      submitModalFlow.hideAllModals();
    }, SUCCESS_MODAL_TIMEOUT);
  }

  function submitInquiryError() {
    submitModalFlow.setErrors({
      errorTitle: "Err-System-001",
      errorDescription: "There was a system error while processing the request."
    });
    submitModalFlow.showFailureModal();
  }

});


// WEBPACK FOOTER //
// ./src/pages/billingInformation/billingInformation.js